import { container, primaryColor } from "assets/jss/material-kit-react.jsx";

const footerStyle = {
  block: {
    color: "inherit",
    margin: "0rem 0.9375rem",
    padding: "0.9375rem 0rem",
    fontWeight: "500",
    fontSize: "14px",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "block"
  },
  gridItem: {
    marginRight: "auto",
  },
  listItem: {
    color: "inherit",
    fontWeight: "500",
    fontSize: "14px",
    textTransform: "uppercase",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    paddingTop: "0px",
    paddingBottom: "0px"
  },
  listItemFirst: {
    fontWeight: "700"
  },
  disclaimer: {
    fontStyle: "italic",
    textAlign: "justify"
  },
  copyright: {
    textTransform: "uppercase",
    borderWidth: "1px 0px 0px 0px",
    borderRadius: "0px"
  },
  left: {
    display: "flex",
    alignItems: "stretch",
    flexDirection: "column"
  },
  right: {
    padding: "15px 0",
    margin: "0",
    float: "right!important"
  },
  footer: {
    padding: "30px",
    textAlign: "left",
    display: "block",
    zIndex: "2",
    position: "relative"
  },
  a: { 
    color: primaryColor,
    textDecoration: "none",
    backgroundColor: "transparent"
  },
  footerWhiteFont: {
    "&,&:hover,&:focus": {
      color: "#FFFFFF"
    }
  },
  container,
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0"
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0px",
    width: "auto"
  },
  icon: {
    width: "18px",
    height: "18px",
    position: "relative",
    top: "3px"
  }
};
export default footerStyle;
